const u = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=900&q=80`;
const px = (id, w = 900) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const CATEGORIES = [
  "Birthday",
  "Anniversary",
  "Festive & Diwali",
  "Wedding & Favors",
  "Corporate",
  "Personalized & Crafts",
];

export const HERO_IMG = u("photo-1784292765863-20dddb419e67");
export const HERO_ACCENT_IMG = px(20699855, 600);

export const OCCASIONS = [
  {
    label: "Birthdays & Anniversaries",
    desc: "Keepsake boxes, candles & handmade cards that say it personally.",
    image: u("photo-1784292877311-fd49ac66ddc8"),
    category: "Birthday",
  },
  {
    label: "Festive & Diwali",
    desc: "Thalis, mithai hampers & artisan diyas for a glowing celebration.",
    image: u("photo-1760192158969-fba5f503404f"),
    category: "Festive & Diwali",
  },
  {
    label: "Weddings & Favors",
    desc: "Hand-painted wooden boxes & jeweled keepsakes your guests keep forever.",
    image: px(175739),
    category: "Wedding & Favors",
  },
  {
    label: "Corporate Executive Gifting",
    desc: "Logo-branded hampers & premium desk treats, delivered pan-India.",
    image: px(27393960),
    category: "Corporate",
  },
  {
    label: "Personalized & Kids Crafts",
    desc: "Hand-painted keepsakes, custom mugs & name-engraved everything.",
    image: px(33927883),
    category: "Personalized & Crafts",
  },
];

export const FALLBACK_PRODUCTS = [
  { id: "f1", name: "Birthday Surprise Trio Box", description: "Three hand-wrapped boxes of treats, keepsakes and a personalized birthday card — ready to gift.", price: 1299, category: "Birthday", image: u("photo-1647221598398-934ed5cb0e4f"), badge: "Bestseller", sku: "AZ-101" },
  { id: "f2", name: "Birthday Balloon Hamper", description: "Festive balloon bunch with a curated gift box, confetti and a custom name tag.", price: 1099, category: "Birthday", image: u("photo-1583875762487-5f8f7c718d14"), badge: null, sku: "AZ-102" },
  { id: "f3", name: "Rose Keepsake & Candle Box", description: "Luxury keepsake box with handmade roses, a scented candle and room for a handwritten note.", price: 1499, category: "Anniversary", image: u("photo-1784292765863-20dddb419e67"), badge: "Handmade", sku: "AZ-103" },
  { id: "f4", name: "Golden Anniversary Tray", description: "Gold-ribboned gift ensemble arranged on a decorative tray — perfect for milestone anniversaries.", price: 1899, category: "Anniversary", image: px(20856313), badge: null, sku: "AZ-104" },
  { id: "f5", name: "Diwali Mithai & Treats Hamper", description: "A beautifully arranged basket of sweets, chocolates and festive nibbles with diyas.", price: 1899, category: "Festive & Diwali", image: px(20699854), badge: "Festive Special", sku: "AZ-105" },
  { id: "f6", name: "Marigold Diya & Floral Thali", description: "Hand-decorated thali with marigolds, diyas and candles for the perfect festive greeting.", price: 999, category: "Festive & Diwali", image: u("photo-1675507325114-32de36df4a76"), badge: null, sku: "AZ-106" },
  { id: "f7", name: "Festive Snack Trays Ensemble", description: "Brass-finish serving trays loaded with festive snacks, namkeen and traditional sweets.", price: 2199, category: "Festive & Diwali", image: u("photo-1695568179701-462c5ea05e41"), badge: null, sku: "AZ-107" },
  { id: "f8", name: "Ornate Favor Box (Set of 10)", description: "Stacked ornate boxes with gold ribbon — elegant wedding return gifts, sold in sets.", price: 1199, category: "Wedding & Favors", image: u("photo-1764650909534-ebe7b1206466"), badge: null, sku: "AZ-108" },
  { id: "f9", name: "Jeweled Trinket Return Gift", description: "A delicate jeweled keepsake box that guests will treasure long after the celebration.", price: 649, category: "Wedding & Favors", image: u("photo-1768777274530-3d7c69d879e2"), badge: null, sku: "AZ-109" },
  { id: "f10", name: "Hand-painted Wooden Keepsake Box", description: "Intricately hand-painted wooden box by local artisans — no two pieces are alike.", price: 1099, category: "Wedding & Favors", image: px(175739), badge: "Hand-painted", sku: "AZ-110" },
  { id: "f11", name: "Executive Leather Keepsake Box", description: "Premium leather-finish box with gold clasp — the corporate gift that means business.", price: 2499, category: "Corporate", image: u("photo-1780744871777-fec13139d281"), badge: "Bestseller", sku: "AZ-111" },
  { id: "f12", name: "Custom Logo Gift Set", description: "Curated care box with your company logo printed on the sleeve and a note card inside.", price: 1599, category: "Corporate", image: u("photo-1637904731042-2ef367b8c00c"), badge: "Custom Logo", sku: "AZ-112" },
  { id: "f13", name: "Teal Prestige Hamper", description: "Luxury turquoise boxes with gold monogram and clasps — for clients and leadership.", price: 2999, category: "Corporate", image: u("photo-1774978238615-881981af6948"), badge: "Custom Logo", sku: "AZ-113" },
  { id: "f14", name: "Custom Photo Mug", description: "Glossy ceramic mug printed with your photos, artwork or an inside joke they'll actually use.", price: 499, category: "Personalized & Crafts", image: px(7873162), badge: "Custom Print", sku: "AZ-114" },
  { id: "f15", name: "Heart Frame Duo", description: "Twin heart-shaped photo frames with a gift pouch — a small gift that carries big feelings.", price: 799, category: "Personalized & Crafts", image: px(7764473), badge: null, sku: "AZ-115" },
  { id: "f16", name: "Classic Name Mug", description: "Minimal ceramic mug with a name or monogram in our signature hand-lettered style.", price: 449, category: "Personalized & Crafts", image: u("photo-1509046725455-ad9638a050e8"), badge: null, sku: "AZ-116" },
];

export const CORP_IMG_1 = px(20856313);
export const CORP_IMG_2 = u("photo-1762504366698-46550e162068");
export const CRAFT_IMG_1 = px(33927883);
export const CRAFT_IMG_2 = px(6963009);
export const ABOUT_IMG = px(7694949);

export const TESTIMONIALS = [
  {
    quote: "The wedding favours were the talk of our reception — every guest asked where they were from. Hand-packed, beautiful and right on time.",
    name: "Priya & Arjun",
    meta: "Wedding & Favors",
  },
  {
    quote: "Ordered festive hampers for our whole team. Logo printed neatly, delivered to every branch. Zero follow-ups needed.",
    name: "Rahul M., HR Manager",
    meta: "Corporate Gifting",
  },
  {
    quote: "Mom's birthday gift had her name engraved and a handwritten note inside. She almost didn't want to open the box.",
    name: "Sneha K.",
    meta: "Personalized Gift",
  },
];
